import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedSelect, {
	SelectOptions,
} from "../../../components/essentials/input/select/AcedSelect";
import AcedInput from "../../../components/essentials/input/text/AcedInput";

const SelectCartellinoStatus = () => {
	const { t } = useTranslation();

	const rightsOptions: SelectOptions = [
		{
			value: "free",
			label: t("cartellinoStatus.free"),
		},
		{
			value: "registered",
			label: t("cartellinoStatus.registered"),
		},
		{
			value: "loan",
			label: t("cartellinoStatus.loan"),
		},
		{
			value: "own",
			label: t("cartellinoStatus.own"),
		},
		{
			value: "none",
			label: t("cartellinoStatus.none"),
		},
	];

	const { control, watch } = useFormContext();

	const watchcartellinoStatus = watch("cartellinoStatus");

	const [hasTeam, setHasTeam] = useState<boolean | null>(null);

	const teamInputs = () => {
		switch (watchcartellinoStatus) {
			case "free":
				return null;
			case "registered":
				return (
					<AcedInput
						control={control}
						name="team"
						label={t("cartellinoStatus.whatTeamRegistered")}
						rules={{ required: t("createJob.validation.required") }}
						placeholder={t("cartellinoStatus.placeholder.yourTeam")}
					/>
				);
			case "loan":
				return (
					<>
						<AcedInput
							control={control}
							name="owningTeam"
							label={t("cartellinoStatus.whatTeamRights")}
							rules={{ required: t("createJob.validation.required") }}
							placeholder={t("cartellinoStatus.placeholder.owningTeam")}
						/>
						<AcedInput
							control={control}
							name="team"
							label={t("cartellinoStatus.whatTeamPlayingFor")}
							rules={{ required: t("createJob.validation.required") }}
							placeholder={t("cartellinoStatus.placeholder.yourTeam")}
						/>
					</>
				);
			case "own":
			case "none":
				return (
					<>
						<AcedSelect
							options={[
								{ value: true, label: t("common.words.yes") },
								{ value: false, label: t("common.words.no") },
								{ value: undefined, label: t("common.words.notSpecify") },
							]}
							label={t("cartellinoStatus.doYouPlayInTeam")}
							value={hasTeam}
							onChange={(value) => setHasTeam(value as boolean)}
						/>
						{hasTeam && (
							<AcedInput
								control={control}
								name="team"
								label={t("cartellinoStatus.whatTeamPlayingFor")}
								rules={{ required: t("createJob.validation.required") }}
								placeholder={t("cartellinoStatus.placeholder.yourTeam")}
							/>
						)}
					</>
				);
		}
	};

	return (
		<>
			<div className="row-group w-100">
				<AcedSelect
					control={control}
					label={t("cartellinoStatus.registrationStatus")}
					options={rightsOptions}
					name="cartellinoStatus"
					rules={{ required: t("createJob.validation.required") }}
					className="w-100"
				/>
			</div>
			<div className="row-group w-100">
				{watchcartellinoStatus && teamInputs()}
			</div>
		</>
	);
};

export default SelectCartellinoStatus;
